var render = function () {
  var _vm$section, _vm$section2, _vm$section3;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isVisible ? _c('div', [_c('v-expansion-panel-header', {
    staticClass: "lighten-5 section__title",
    class: ['clickable', _vm.isModified ? 'blue' : 'blue-grey']
  }, [(_vm$section = _vm.section) !== null && _vm$section !== void 0 && _vm$section.icon ? _c('v-icon', {
    staticClass: "mx-3"
  }, [_vm._v(_vm._s((_vm$section2 = _vm.section) === null || _vm$section2 === void 0 ? void 0 : _vm$section2.icon))]) : _vm._e(), _vm._v(" " + _vm._s((_vm$section3 = _vm.section) === null || _vm$section3 === void 0 ? void 0 : _vm$section3.title) + " "), _c('v-spacer')], 1), _c('v-expansion-panel-content', [_c('div', {
    key: _vm.isExistedDataChanged
  }, [_vm._t("section")], 2), _c('v-fade-transition', [_c('v-card-actions', [_vm.canShowSaveButton ? _c('v-btn', {
    attrs: {
      "block": "",
      "color": "warning",
      "loading": _vm.isSaving
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments);
      }
    }
  }, [_vm._v(" SAVE ")]) : _vm._e()], 1)], 1)], 1)], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }